<template>
  <div class="modal_content_inner__wrapper">
    <template v-if="isInner">
      <h4 class="header">Справочник</h4>
    </template>
    <template v-else>
      <div class="admin_topbar">
        <div class="admin_topbar_mainblock">
          <h1 class="header" :class="{ 'inner-header': isInner }">
            Справочник
          </h1>
          <div class="filters">
            <OrangeIcon1
              class="orangeIcon1"
              @click="handleCreate('folder')"
            ></OrangeIcon1>
            <OrangeIcon2
              class="orangeIcon2"
              @click="handleCreate('file')"
            ></OrangeIcon2>
          </div>
        </div>
      </div>
    </template>

    <div class="modal_content_inner__wrapper" :class="{ view: !isInner }">
      <template v-if="isInner">
        <div class="nav-wrapper" style="margin-top: 25px; margin-bottom: 10px;">
          <div class="col s12">
            <a
                class="breadcrumb"
                v-for="(level, i) in path"
                :key="level.id"
                @click="cutPathStack(i)"
            >{{ level.name }}</a
            >
          </div>
        </div>
      </template>
      <template v-else>
        <div class="nav-wrapper">
          <div class="col s12">
            <a
                class="breadcrumb"
                v-for="(level, i) in path"
                :key="level.id"
                @click="cutPathStack(i)"
            >{{ level.name }}</a
            >
          </div>
        </div>
      </template>

      <table>
        <tr
          v-for="entry in currentFolder"
          class="library-entry"
          :key="entry.id"
          @click="handleClick(entry)"
        >
          <td>
            <OrangeIcon3
              class="orangeIcon3"
              v-if="parseInt(entry.isFolder)"
            ></OrangeIcon3>
            <OrangeIcon4 class="orangeIcon4" v-else></OrangeIcon4>
          </td>
          <td v-if="entry.edit" class="name">
            <input type="text" v-model="entry.name" />
          </td>
          <td v-else class="name">{{ entry.name }}</td>
          <td
            @click.stop="handleControl"
            class="row-control-buttons"
            v-if="!isInner"
          >
            <div class="verticaldots__wrapper">
              <VerticalDots></VerticalDots>
              <div class="dots_menu">
                <p @click.stop="handleEdit(entry)">
                  <EditIcon></EditIcon>
                  <tempate v-if="entry.edit">Сохранить</tempate>
                  <template v-else>Редактировать</template>
                </p>
                <p @click.stop="handleDelete(entry)">
                  <DeleteIcon></DeleteIcon> Удалить
                </p>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div id="modal" class="modal_right" v-if="isModal1Active">
      <div class="modal_content">
        <div class="content">
          <div class="table__wrapper">
            <table v-if="currentFile.id">
              <th>№</th>
              <th>Тип ресурсов</th>
              <th>Название работ</th>
              <th>Ед. измерения</th>
              <th>Количество</th>
              <th>Цена за единицу</th>
              <th>Наценка</th>
              <th>Цена для заказчика</th>
              <th>Стоимость для заказчика</th>
              <th>Действия</th>

              <tr>
                <td>1</td>
                <td>Раздел</td>
                <td v-if="currentFile.edit">
                  <input type="text" v-model="currentFile.name" />
                </td>
                <td
                  v-else
                  v-html="
                    currentFile.name ? currentFile.name : '<i>[Название]</i>'
                  "
                ></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ countOperationPrice(currentFile).toFixed(2) }}</td>
                <td @click.stop="handleControl" class="row-control-buttons">
                  <VerticalDots></VerticalDots>
                  <div class="dots_menu">
                    <p @click="handleAdd('entry', currentFile.id)">
                      <AddIcon></AddIcon> Добавить
                    </p>
                    <p @click="handleEdit(currentFile)">
                      <EditIcon></EditIcon>
                      <template v-if="currentFile.edit">
                        Сохранить
                      </template>
                      <template v-else>
                        Редактировать
                      </template>
                    </p>
                  </div>
                </td>
              </tr>
              <template
                v-for="(entry, j) in currentFile.elements"
                :key="entry.id"
                :class="{ bold: currentFile.elements }"
              >
                <tr>
                  <td>{{ `1.${j + 1}` }}</td>
                  <td>{{ entry.type }}</td>

                  <td v-if="entry.edit">
                    <input type="text" v-model="entry.name" />
                  </td>
                  <td
                    v-else
                    v-html="entry.name ? entry.name : '<i>[Название]</i>'"
                  ></td>

                  <td v-if="entry.edit">
                    <select v-model="entry.measureType">
                      <option v-for="type in measureTypes" :key="type">
                        {{ type }}
                      </option>
                    </select>
                  </td>
                  <td
                    v-else
                    v-html="
                      entry.measureType
                        ? entry.measureType
                        : '<i>[Единицы измерения]</i>'
                    "
                  ></td>

                  <td v-if="entry.edit">
                    <input type="number" min="0" v-model="entry.quantity" />
                  </td>
                  <td v-else>{{ entry.quantity }}</td>

                  <td>
                    {{ (countEntryCost(entry) / entry.quantity).toFixed(2) }}
                  </td>

                  <td>
                    {{
                      (
                        (countEntryPrice(entry) * 100) / countEntryCost(entry) -
                        100
                      ).toFixed(2)
                    }}
                  </td>
                  <td>
                    {{ (countEntryPrice(entry) / entry.quantity).toFixed(2) }}
                  </td>
                  <td>
                    {{ countEntryPrice(entry).toFixed(2) }}
                  </td>
                  <td @click.stop="handleControl" class="row-control-buttons">
                    <VerticalDots></VerticalDots>
                    <div class="dots_menu">
                      <p @click="handleAdd('subentry', currentFile.id, entry.id)">
                        <AddIcon></AddIcon> Добавить
                      </p>
                      <p @click="handleEdit(entry)">
                        <EditIcon></EditIcon>
                        <template v-if="entry.edit">
                          Сохранить
                        </template>
                        <template v-else>
                          Редактировать
                        </template>
                      </p>
                      <p @click="handleDeleteFromFile('entry', entry.id)">
                        <DeleteIcon></DeleteIcon> Удалить
                      </p>
                    </div>
                  </td>
                </tr>
                <template
                  v-for="(subentry, k) in entry.elements"
                  :key="subentry.id"
                >
                  <tr>
                    <td>{{ `1.${j + 1}.${k + 1}` }}</td>

                    <td v-if="subentry.edit">
                      <select v-model="subentry.type">
                        <option v-for="type in resourceTypes" :key="type">
                          {{ type }}
                        </option>
                      </select>
                    </td>
                    <td
                      v-else
                      v-html="
                        subentry.type ? subentry.type : '<i>[Тип ресурса]</i>'
                      "
                    ></td>

                    <td v-if="subentry.edit">
                      <input type="text" v-model="subentry.name" />
                    </td>
                    <td
                      v-else
                      v-html="
                        subentry.name ? subentry.name : '<i>[Название]</i>'
                      "
                    ></td>

                    <td v-if="subentry.edit">
                      <select v-model="subentry.measureType">
                        <option v-for="type in measureTypes" :key="type">
                          {{ type }}
                        </option>
                      </select>
                    </td>
                    <td
                      v-else
                      v-html="
                        subentry.measureType
                          ? subentry.measureType
                          : '<i>[Единицы измерения]</i>'
                      "
                    ></td>

                    <td v-if="subentry.edit">
                      <input
                        type="number"
                        min="0"
                        v-model.number="subentry.quantity"
                      />
                    </td>
                    <td v-else>{{ subentry.quantity }}</td>

                    <td v-if="subentry.edit">
                      <input
                        type="number"
                        min="0"
                        v-model.number="subentry.cost"
                      />
                    </td>
                    <td v-else>{{ subentry.cost }}</td>

                    <td v-if="subentry.edit">
                      <input
                        type="number"
                        min="0"
                        v-model.number="subentry.markup"
                      />
                    </td>
                    <td v-else>{{ subentry.markup }}</td>
                    <td>
                      {{
                        Math.ceil(
                          subentry.cost * (100 + Number(subentry.markup))
                        ) / 100
                      }}
                    </td>
                    <td>
                      {{
                        (
                          (Math.ceil(
                            subentry.cost * (100 + Number(subentry.markup))
                          ) /
                            100) *
                          subentry.quantity
                        ).toFixed(2)
                      }}
                    </td>
                    <td @click.stop="handleControl" class="row-control-buttons">
                      <VerticalDots></VerticalDots>
                      <div class="dots_menu">
                        <p @click="handleEdit(subentry)">
                          <EditIcon></EditIcon>
                          <template v-if="subentry.edit">
                            Сохранить
                          </template>
                          <template v-else>
                            Редактировать
                          </template>
                        </p>
                        <p @click="handleDeleteFromFile('subentry', subentry.id)"><DeleteIcon></DeleteIcon> Удалить</p>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </table>
          </div>
          <div class="modal_buttons_block">
            <a @click="isModal1Active = false; this.setOperation()" class="modal-close button2">Закрыть</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import OrangeIcon1 from "../components/Icons/OrangeIcon1";
import OrangeIcon2 from "../components/Icons/OrangeIcon2";
import OrangeIcon3 from "../components/Icons/OrangeIcon3";
import OrangeIcon4 from "../components/Icons/OrangeIcon4";
import VerticalDots from "../components/Icons/VerticalDots";
import EditIcon from "../components/Icons/EditIcon";
import DeleteIcon from "../components/Icons/DeleteIcon";
import AddIcon from "../components/Icons/AddIcon";

export default {
  data: () => {
    return {
      currentFile: {},
      path: [{ id: 0, name: "Все" }],
      resourceTypes: [],
      measureTypes: [],
      // currentFileElementsLastId: null,
      library: [],
      isModal1Active: false,
    };
  },
  components: {
    AddIcon,
    OrangeIcon1,
    OrangeIcon2,
    OrangeIcon3,
    OrangeIcon4,
    VerticalDots,
    EditIcon,
    DeleteIcon,
  },
  mounted() {
    this.initLibrary();
  },
  watch: {
    path: {
      handler(value) {
        if (value.length < 1) {
          this.path.push({ id: 0, name: "Все" });
        }
      },
      deep: true,
    },
  },
  props: ["isInner"],
  emits: ["sendFromLibrary"],
  computed: {
    currentFolder: {
      get() {
        if (this.path.length == 1) {
          return this.library;
        }
        const cur = this.path.reduce((last, cur) => {
          if (cur.id == 0) {
            return this.library;
          }
          if (!last.id) {
            return last.find((i) => i.id == cur.id);
          }
          return last.elements.find((i) => i.id == cur.id);
        }, {});
        return cur.elements;
      },
      set(val) {
        if (this.path.length == 1) {
          this.library = val;
        }
        let cur = this.path.reduce((last, cur) => {
          if (cur.id == 0) {
            return this.library;
          }
          if (!last.id) {
            return last.find((i) => i.id == cur.id);
          }
          return last.elements.find((i) => i.id == cur.id);
        }, {});
        cur.elements = val;
      },
    },
    // currentLastId() {
    //   return this.currentFolder.reduce(
    //     (max, i) => (max = max > i.id ? max : i.id),
    //     0
    //   );
    // },
    // currentFileElementsLastId() {
    //   return this.currentFile.elements.reduce((max, cur) => {
    //     max = cur.elements.reduce(
    //       (acc, i) => (acc = acc > i.id ? acc : i.id),
    //       0
    //     );
    //     max = max > cur.id ? max : cur.id;
    //     return max;
    //   }, 0);
    // },
  },
  methods: {
    handleClick(entry) {
      if (parseInt(entry.isFolder)) {
        this.goToFolder(entry);
      } else {
        this.openFile(entry);
      }
    },
    handleControl(e) {
      document.querySelectorAll(".dots_menu").forEach((el) => {
        if (el !== e.currentTarget.querySelector(".dots_menu")) {
          el.style.display = "none";
        }
      });
      if (
        e.currentTarget.querySelector(".dots_menu").style.display === "none"
      ) {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "flex");
      } else {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "none");
      }
    },
    goToFolder(folder) {
      if (!folder.edit) {
        this.path.push({ id: folder.id, name: folder.name });
      }
    },
    openFile(file) {
      if (this.isInner) {
        alert("Добавлено");
        this.$emit("sendFromLibrary", file);
      } else {
        if (!file.edit) {
          this.currentFile = file;
          this.isModal1Active = true;

          //this.modal.open();
        }
      }
    },
    cutPathStack(index) {
      this.path = this.path.slice(0, index + 1);
    },
    handleDelete(entry) {
      const message = parseInt(entry.isFolder)
        ? `В папке содержатся элементы в количестве: ${entry.elements.length}\nДействительно хотите удалить ${entry.name}?`
        : `Действительно хотите удалить ${entry.name}?`;
      if (confirm(message)) {
        this.currentFolder = this.currentFolder.filter((i) => i.id != entry.id);
        this.deleteFile(entry);
      }
    },
    handleCreate(type) {
      if (type == "file") {
        this.currentFolder.push({
          // id: this.currentLastId + 1,
          edit: true,
          elements: [],
        });
      } else if (type == "folder") {
        this.currentFolder.push({
          // id: this.currentLastId + 1,
          edit: true,
          isFolder: 1,
          elements: [],
        });
      }
    },

    countOperationPrice(operation) {
      return operation.elements.reduce(
        (acc, i) =>
          (acc += i.elements.reduce(
            (acc, j) =>
              (acc += (j.cost * j.quantity * (100 + Number(j.markup))) / 100),
            0
          )),
        0
      );
    },
    countEntryPrice(entry) {
      return entry.elements.reduce(
        (acc, i) =>
          (acc += (i.cost * i.quantity * (100 + Number(i.markup))) / 100),
        0
      );
    },
    countEntryCost(entry) {
      return entry.elements.reduce(
        (acc, i) => (acc += Number(i.cost) * i.quantity),
        0
      );
    },
    async handleAdd(type, fileId, operationId = null) {
      const id = await this.createOperation(fileId, operationId);
      switch (type) {
        case "entry":
          this.currentFile.elements.push({
            // id: ++this.currentFileElementsLastId,
            id,
            name: "",
            type: "Работа",
            measureType: "",
            quantity: 1,
            cost: 0,
            markup: 0,
            elements: [],
          });
          break;
        case "subentry":
          this.currentFile.elements
            .find((j) => j.id == operationId)
            .elements.push({
              // id: ++this.currentFileElementsLastId,
              id,
              name: "",
              type: "",
              measureType: "",
              quantity: 1,
              cost: 0,
              markup: 0,
            });
          break;
      }
    },
    handleEdit(el) {
      if (el.edit) {
        if (!Object.keys(el).includes("type")) {
          this.setFile(el);
        }
      }
      el.edit = !el.edit;
      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        M.FormSelect.init(elems, {});
      }, 0);
    },
    handleDeleteFromFile(type, id) {
      if (confirm("Удалить?")) {
        switch (type) {
          case "entry":
            this.currentFile.elements = this.currentFile.elements.filter(
              (j) => j.id != id
            );
            this.deleteOperation(id);
            break;
          case "subentry":
            this.currentFile.elements.map(
              (j) => (j.elements = j.elements.filter((k) => k.id != id))
            );
            this.deleteOperation(id);
            break;
        }
      }
    },
    async initLibrary() {
      let resp = await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getLibrary",
        }),
      });
      const library = await resp.json();
      this.createRootLibraryStructure(library);
      this.loadLibraryFiles(library);

      resp = await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getTypes",
          front: true,
        }),
      });
      const types = await resp.json();
      this.measureTypes = types.measureTypes;
      this.resourceTypes = types.resourceTypes;
    },
    async setFile(file) {
      const id = file.id;
      const name = file.name;
      const isFolder = file.isFolder;
      const parentFolderId = this.path[this.path.length - 1].id;

      let resp = await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "setFile",
          id,
          name,
          isFolder,
          parentFolderId,
        }),
      });

      const fileId = await resp.text();
      if (fileId != 0) {
        file.id = fileId;
      }
    },
    async setOperation() {
      await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "setOperation",
          operation: this.currentFile,
        }),
      });
      // this.library = [];
      // this.initLibrary();
    },
    createRootLibraryStructure(library) {
      library
        .filter((level) => level.parentFolderId == 0)
        .forEach((file) => {
          this.library.push(file);
          this.createFileStructure(library, file);
        });
    },
    createFileStructure(library, file) {
      file.elements = [];
      library
        .filter((level) => level.parentFolderId == file.id)
        .forEach((element) => {
          file.elements.push(element);
          this.createFileStructure(library, element);
        });
    },
    async loadLibraryFiles(library) {
      const operations = library
        .filter((i) => i.isFolder == 0)
        .reduce((operations, operation) => {
          operations.push(operation.id);
          return operations;
        }, []);

      let resp = await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getLibraryOperations",
          operations,
        }),
      });
      const serverOperations = await resp.json();

      serverOperations
        .filter((i) => !i.parentWork)
        .map((i) => {
          i.elements = [];
          library.find((j) => j.id == i.operationId).elements.push(i);
        });
      serverOperations
        .filter((i) => i.parentWork)
        .map((i) => {
          library
            .find((j) => j.id == i.operationId)
            .elements.find((k) => k.id == i.parentWork)
            .elements.push(i);
        });
    },
    async deleteFile(entry) {
      const findLayerIds = (layer) => {
        return Array.from(
          new Set(
            layer.elements.reduce(
              (ids, el) => {
                ids.push(el.id);
                if (el.elements && el.elements.length) {
                  ids.push(...findLayerIds(el));
                }
                return ids;
              },
              [layer.id]
            )
          )
        );
      };
      await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "deleteFile",
          ids: findLayerIds(entry),
        }),
      });
    },
    async deleteOperation(id) {
      await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "deleteOperation",
          id,
        }),
      });
    },
    async createOperation(fileId, operationId) {
      let resp = await fetch("/backend/library.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "createOperation",
          operationId: fileId,
          parentWork: operationId,
        }),
      });
      return await resp.text();
    },
  },
};
</script>

<style lang="stylus" scoped>
.white-space {
  width: calc(100% - 130px);
  height: 60px;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  top: 0;
  left: 130px;
}

.breadcrumb {
  color: #888;

  &:last-child {
    color: #555;
  }

  &:before {
    content: '→';
    color: #888;
  }
}

.name {
  width: 100%;
}

.library-entry:hover {
  background-color: #eee;
}


.row-control-buttons {
  width: 90px;
  display: block;
}

.table-button {
  border: 1px solid silver;
  cursor: pointer;
  color: #000000DE;
}

.modal {
  width: 100%;
  max-width: 1400px;
}

.bold {
  font-weight: bold;
}

.section {
  background-color: #eee;
}

/* Если Справочник вызывается внутри Сметы */
.inner-header {
  position: static;
}
  .orangeIcon1 {
    margin-right:20px;
  }
  .modal_content_inner__wrapper {
    flex-grow: 1;
  }
</style>
